import FormArrayImagesField from "./fields/Form/ArrayImagesField.vue"
import DetailArrayImagesField from "./fields/Detail/ArrayImagesField.vue"
import IndexArrayImagesField from "./fields/Index/ArrayImagesField.vue"

const arrayImagesFieldSetup = (app) => {

    /**
     * Register Fields
     */
    app.component('form-array-images-field', FormArrayImagesField)
    app.component('detail-array-images-field', DetailArrayImagesField)
    app.component('index-array-images-field', IndexArrayImagesField)

}

export { arrayImagesFieldSetup }